export const SCREEN_W = 128;
export const SCREEN_H = 128;
export class Screen {
  readonly ctx: CanvasRenderingContext2D;
  private readonly canvas: HTMLCanvasElement;
  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) throw new Error('2D canvas context unavailable');
    this.ctx = ctx;
    this.ctx.imageSmoothingEnabled = false;
    window.addEventListener('resize', () => this.resize());
    this.resize();
  }
  resize(): void {
    const vw = Math.max(window.innerWidth, SCREEN_W);
    const vh = Math.max(window.innerHeight, SCREEN_H);
    const scale = Math.max(1, Math.floor(Math.min(vw / SCREEN_W, vh / SCREEN_H)));
    const w = SCREEN_W * scale;
    const h = SCREEN_H * scale;
    this.canvas.style.width = `${w}px`;
    this.canvas.style.height = `${h}px`;
    this.canvas.style.position = 'absolute';
    this.canvas.style.left = `${Math.floor((window.innerWidth - w) / 2)}px`;
    this.canvas.style.top = `${Math.floor((window.innerHeight - h) / 2)}px`;
  }
  clear(color: string): void {
    this.ctx.fillStyle = color;
    this.ctx.fillRect(0, 0, SCREEN_W, SCREEN_H);
  }
}
